<!-- BasePopup.vue (admin) -->
<template tag="관리자 팝업 컴포넌트">
  <div class="v-application__wrap">
    <v-card>
      <v-card-title class="bg-primary d-flex align-center" v-if="$slots.title">
        <slot name="title"></slot>
        <v-spacer />
        <v-btn
          @click="onClickClose"
          class="elevation-0"
          icon="mdi-close"
          variant="plain"
          density="compact"
          :retain-focus="false"
        />
        <!-- retain-focus : 다이얼로그가 열릴 때 포커스가 다이얼로그 내부로 이동하지 않도록 설정-->
      </v-card-title>
      <v-card-actions
        class="mt-3 text-left text-h6"
        style="padding-bottom: 0"
        v-if="$slots.subTitle"
      >
        <slot name="subTitle"></slot>
      </v-card-actions>

      <v-card-text v-if="$slots.header">
        <slot name="header"></slot>
      </v-card-text>

      <v-card-text v-if="$slots.contents" :class="`v-card-${size}`">
        <slot name="contents"></slot>
      </v-card-text>
      <v-card-actions v-if="$slots.footer">
        <slot name="footer"></slot>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script setup lang="ts">
/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel();

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps<{
  size?: "small" | "medium" | "large";
}>();
const { size = "medium" } = props;

/* ------------------------------------------------------------
                          Methods
   ------------------------------------------------------------ */
/** 닫기 버튼 클릭 시 */
const onClickClose = () => {
  model.value = false;
};
</script>
<style scoped>
.v-application__wrap {
  min-height: auto !important;
}
.v-card {
  display: flex;
  flex-direction: column;
}
.v-card-actions {
  justify-content: center;
}
.v-card-small {
  max-height: 50vh;
  overflow-y: auto;
}
.v-card-medium {
  max-height: 64vh;
  overflow-y: auto;
}
.v-card-large {
  max-height: 76vh;
  overflow-y: auto;
}
</style>
